export default {
  id: 'problemDescription/SYMPTOMS_BY_DOCTOR/v1',
  formSchema: {
    title: 'encounter:widget.problemDescription.symptomsByDoctor',
    type: 'object',
    required: ['id001'],
    properties: {
      id001: {
        type: 'string',
        title: 'encounter:widget.problemDescription.symptomsByDoctor',
        minLength: 1
      }
    }
  },
  uiSchema: {
    id001: { 'ui:widget': 'customCKEditorWidget' },
    'x-customClass': 'problem-description-widget'
  }
};
